export const getErrorMessage = (error: any, defaultMassage: string) =>
  error.response?.data?.ErrorMessage ?? defaultMassage;
